import { render, staticRenderFns } from "./invoiceItemsInfoBox.vue?vue&type=template&id=23b635f2&"
import script from "./invoiceItemsInfoBox.vue?vue&type=script&lang=ts&"
export * from "./invoiceItemsInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports